<template>
  <a-modal
    title="添加章"
    :visible="value"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
    :bodyStyle="{ paddingRight: '110px' }"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      layout="horizontal"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="名称" prop="name">
            <a-input v-model="form.name" placeholder="请输入章名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="描述" prop="description">
            <a-textarea v-model="form.description" placeholder="请输入描述" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="24">
          <a-form-model-item label="课时" prop="period">
            <a-input v-model="form.period" placeholder="请输入课时" />
          </a-form-model-item>
        </a-col> -->
        <a-col :span="24">
          <a-form-model-item label="封面" prop="tempIcon">
            <IconUpload v-model="form.tempIcon" :imageUrl="form.icon" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { addSection, getSectionById, updateSection } from '@/api/course/course'
import IconUpload from '@/components/Upload/IconUpload'
import { uploadMulti } from '@/api/upload'

export default {
  components: {
    IconUpload
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    afterSubmit: {
      type: Function,
      default: function() {}
    },
    mode: {
      type: Object,
      default: () => ({
        type: 'add',
        id: undefined
      })
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      confirmLoading: false,
      levels: ['新手入门', '高手进阶'],
      form: {
        name: undefined,
        description: undefined,
        // period: undefined,
        icon: undefined,
        tempIcon: undefined
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'change'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'change'
          }
        ],
        // period: [
        //   {
        //     required: true,
        //     message: '请输入昵称',
        //     trigger: 'change'
        //   }
        // ],
        tempIcon: [
          {
            required: false
          }
        ]
      }
    }
  },
  computed: {
    courseId() {
      return this.$route.query.courseId
    }
  },
  watch: {
    mode(m) {
      if (m.type === 'update') {
        getSectionById(m.id).then(res => {
          let result = res.result
          Object.keys(this.form).forEach(key => {
            this.form[key] = result[key]
          })
        })
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs.ruleForm.resetFields()
      this.form.icon = undefined
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const { form, courseId, mode } = this
          this.confirmLoading = true
          let values = { ...form }
          let icons = form.tempIcon && [form.tempIcon]
          uploadMulti(icons)
            .then(arr => {
              if (arr && arr.length > 0) {
                values.icon = arr[0].url
              }
              if (mode.type === 'add') {
                return addSection({ id: courseId }, values)
              } else {
                return updateSection(mode.id, values)
              }
            })
            .then(resp => {
              if (resp.code === 200) {
                this.$notification['success']({
                  message: '成功',
                  description: `课程 ${form.name} 添加成功`
                })
              }
              this.resetForm()
              this.$emit('input', false)
              this.afterSubmit && this.afterSubmit()
            })
            .finally(() => {
              this.confirmLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped></style>
